<template>
    <div id="homepage">
        <div class="hero hero-drops" data-aos="fade">

            <svg class="drop-gray-1" width="140" height="162" viewBox="0 0 140 162" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d)">
                    <path d="M119.1 57.2C119.1 88.8 93.4999 114.4 61.8999 114.4C30.2999 114.4 4.69995 88.8 4.69995 57.2C4.69995 25.6 30.2999 0 61.8999 0C93.4999 0 119.1 25.7 119.1 57.2Z" fill="#EDF0F7"/>
                    <path d="M135.8 140.7C135.8 147.9 130 153.7 122.8 153.7C115.6 153.7 109.8 147.9 109.8 140.7C109.8 133.5 115.6 127.7 122.8 127.7C130 127.7 135.8 133.6 135.8 140.7Z" fill="#EDF0F7"/>
                </g>
                <defs>
                    <filter id="filter0_d" x="0.699951" y="0" width="139.1" height="161.7" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                    </filter>
                </defs>
            </svg>

            <svg class="drop-gray-2" width="224" height="223" viewBox="0 0 224 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M223.1 111.5C223.1 173.1 173.2 223 111.6 223C49.9999 223 0.0998535 173.1 0.0998535 111.5C0.0998535 49.9 49.9999 0 111.6 0C173.2 0 223.1 49.9 223.1 111.5Z" fill="#EDF0F7"/>
            </svg>

            <svg class="drop-red-1" width="851" height="413" viewBox="0 0 851 413" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M159.9 -239.8C95.4 -190.4 44.4999 -124 18.5999 -46.9999C-39.0001 123.8 45.1 347.4 226.9 400C396.7 449.1 591.3 345.3 622 166.2C638.8 68.2001 651.7 -26.2999 752.4 -72.2999C773 -81.6999 794.9 -87.9999 814.8 -98.7999C923.6 -157.7 755.8 -243 707.4 -268.3C597.4 -325.8 468.1 -350.3 345.7 -325.1C278.5 -311.2 214.3 -281.5 159.9 -239.8Z" fill="white"/>
                <path d="M239.051 -185.092C183.542 -142.578 139.737 -85.4329 117.447 -19.1658C67.8755 127.827 140.253 320.26 296.712 365.528C442.844 407.784 610.32 318.453 636.74 164.317C651.199 79.9768 662.301 -1.35107 748.964 -40.9393C766.693 -49.029 785.54 -54.4509 802.667 -63.7455C896.301 -114.436 751.89 -187.846 710.237 -209.619C615.569 -259.105 504.292 -280.19 398.953 -258.502C341.12 -246.54 285.869 -220.979 239.051 -185.092Z" fill="url(#paint0_linear)"/>
                <defs>
                <linearGradient id="paint0_linear" x1="467.064" y1="423.126" x2="467.064" y2="-182.715" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>   

            <svg class="drop-red-2" width="109" height="133" viewBox="0 0 109 133" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32.5" cy="100.5" r="32.5" fill="url(#paint0_linear)"/>
                <circle cx="99" cy="10" r="10" fill="url(#paint1_linear)"/>
                <defs>
                <linearGradient id="paint0_linear" x1="32.4317" y1="137.764" x2="32.4317" y2="76.5202" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint1_linear" x1="98.979" y1="21.4658" x2="98.979" y2="2.62161" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>      

            <svg class="drop-red-3" width="296" height="447" viewBox="0 0 296 447" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M446.6 223.4C446.6 346.5 346.8 446.3 223.7 446.3C100.6 446.3 0.799805 346.5 0.799805 223.4C0.799805 100.3 100.6 0.5 223.7 0.5C346.8 0.5 446.6 100.3 446.6 223.4Z" fill="white"/>
                <circle cx="224" cy="184" r="184" fill="url(#paint0_linear)"/>
                <defs>
                <linearGradient id="paint0_linear" x1="223.614" y1="394.971" x2="223.613" y2="48.2376" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>                           

            <svg class="drop-red-4" width="353" height="353" viewBox="0 0 353 353" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="176.5" cy="176.5" r="176.5" fill="url(#paint0_linear)"/>
                <defs>
                <linearGradient id="paint0_linear" x1="176.129" y1="378.871" x2="176.129" y2="46.2714" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>            

            <div class="slider">
                <Slick ref="slick-hero-home" :options="slickOptions">
                    <div class="slide">
                        <div class="image">
                            <img class="thumb" src="img/home/home-slider-1.png" />
                            <svg class="holder" width="1234" height="991" viewBox="0 0 1234 991" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M73.5499 0C58.6499 29.9 45.7499 60.8 35.0499 92.6C-77.4501 426.3 86.8499 863.5 442.05 966.3C773.85 1062.3 1154.25 859.4 1214.25 509.5C1226.25 439.7 1237.15 370.8 1255.75 307.1V0.100006H73.5499V0Z" fill="#FDC500"/>
                            </svg>
                        </div>
                        <div class="caption">
                            <div class="small h4">Immagina di connettere i tuoi clienti e le tue risorse umane ad entusiasmanti</div>
                            <div class="text h1">soluzioni di travel booking</div>
                            <div class="small h4"></div>
                        </div>
                    </div>

                    <div class="slide">
                        <div class="image">
                            <img class="thumb" src="img/home/home-slider-2.png" />
                            <svg class="holder" width="1234" height="991" viewBox="0 0 1234 991" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M73.5499 0C58.6499 29.9 45.7499 60.8 35.0499 92.6C-77.4501 426.3 86.8499 863.5 442.05 966.3C773.85 1062.3 1154.25 859.4 1214.25 509.5C1226.25 439.7 1237.15 370.8 1255.75 307.1V0.100006H73.5499V0Z" fill="#FDC500"/>
                            </svg>
                        </div>
                        <div class="caption">
                            <div class="small h4 not-first">Immagina di dare</div>
                            <div class="text h1">ai tuoi clienti e ai tuoi collaboratori</div>
                            <div class="small h4 not-first">una grande esperienza utente.</div>
                        </div>
                    </div>

                    <div class="slide">
                        <div class="image">
                            <img class="thumb" src="img/home/home-slider-3.png" />
                            <svg class="holder" width="1234" height="991" viewBox="0 0 1234 991" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M73.5499 0C58.6499 29.9 45.7499 60.8 35.0499 92.6C-77.4501 426.3 86.8499 863.5 442.05 966.3C773.85 1062.3 1154.25 859.4 1214.25 509.5C1226.25 439.7 1237.15 370.8 1255.75 307.1V0.100006H73.5499V0Z" fill="#FDC500"/>
                            </svg>
                        </div>
                        <div class="caption">
                            <div class="small h4 not-first">Immagina disponibilità di viaggio aggiornate in tempo reale,</div>
                            <div class="text h1">coordinate con la tua comunicazione</div>
                            <div class="small h4 not-first">e la tua brand identity.</div>
                        </div>
                    </div>
                </Slick>

                <div class="slider--nav">
                    <div id="hero-slider-prev" class="arrow"><SvgChevronLeft /></div>
                    <div id="hero-slider-next" class="arrow"><SvgChevronRight /></div>
                </div>
            </div>
        </div>

        <b-container class="text-center" data-aos="fade-up">
            <section>
                <h1 class="section--title h2">Soluzioni di online travel booking</h1>
                <p class="section--subtitle">integrate, brandizzate, capaci comunicare i tuoi valori e i tuoi messaggi.</p>

                <div class="extraQuote">
                    <div class="image">
                        <svg width="1214" height="349" viewBox="0 0 1214 349" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M151.705 10.7131C122.438 18.0432 93.8587 29.3201 69.6412 47.1377C45.4238 64.9554 26.0269 89.8775 18.337 118.521C8.35157 155.848 14.6642 194.641 3.53103 231.967C-5.76571 263.092 3.64581 296.584 27.6337 319.251C51.0477 341.354 85.1358 350.939 117.502 348.346C149.869 345.752 180.628 331.769 206.453 312.259C220.111 301.997 232.736 290.044 248.116 282.601C276.236 268.843 309.979 271.549 340.395 279.556C370.81 287.563 399.848 300.419 430.722 306.17C461.597 311.921 496.258 309.553 520.591 290.044C540.332 274.256 550.662 249.221 554.105 224.412C557.548 199.715 554.908 173.778 543.431 151.675C529.543 124.949 504.407 105.778 479.731 87.9604C456.891 71.496 433.821 55.3699 408.915 42.0631C357.152 14.3218 297.928 0 238.704 0C209.437 0 180.169 3.49586 151.705 10.7131Z" fill="url(#paint0_linear)"/>
                        <path d="M1188.04 272.054L203.998 256.614C192.526 256.614 182.469 249.28 179.169 238.472L130.768 96.1915C125.739 79.8251 138.232 63.3042 155.597 63.3042H1128.33C1139.8 63.3042 1149.86 70.7154 1153.16 81.4463L1212.87 239.166C1217.9 255.533 1205.49 272.054 1188.04 272.054Z" fill="#FDC500"/>
                        <path d="M1170.76 255.842H186.712C175.24 255.842 165.183 248.508 161.883 237.7L113.482 79.9793C108.454 63.6129 120.947 47.092 138.311 47.092H1122.36C1133.83 47.092 1143.89 54.5033 1147.19 65.2341L1195.59 222.954C1200.62 239.321 1188.2 255.842 1170.76 255.842Z" fill="#39414E"/>
                        <path d="M312.35 98.1216L293.885 142.435C302.921 148.456 307.4 158.569 307.4 169.455C307.4 189.604 292.628 203.654 272.513 203.654C254.049 203.654 237.706 191.534 237.706 169.455C237.706 158.955 241.791 150.155 247.134 142.049L277.856 98.1216H312.35ZM384.48 169.377C384.48 189.527 369.708 203.577 349.672 203.577C331.207 203.577 314.864 191.457 314.864 169.377C314.864 158.878 318.95 150.077 324.293 141.971L355.015 98.0444H389.43L370.965 142.357C380.001 148.456 384.48 158.492 384.48 169.377Z" fill="white"/>
                        <defs>
                        <linearGradient id="paint0_linear" x1="277.171" y1="374.32" x2="277.171" y2="45.7156" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF974F"/>
                        <stop offset="0.00128142" stop-color="#FF974F"/>
                        <stop offset="1" stop-color="#FF5652"/>
                        </linearGradient>
                        </defs>
                        </svg>                        
                    </div>
                    <div class="text">Scegli il travel per la comunicazione e il marketing del tuo brand, connettiti al travel 4.0 di Vivamod.</div>
                </div>
            </section>
        </b-container>

        <b-container>
            <section class="b-cards">

                <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('concorsi',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-1.png')"></div>
                    <div class="b-card--text">
                        <h2 class="b-card--title">Promo e concorsi</h2>
                        <p class="b-card--link">
                            Real time experience
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                            </svg>                            
                        </p>
                    </div>
                </div>

                <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('incentive',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-2.png')"></div>
                    <div class="b-card--text">
                        <h2 class="b-card--title">Incentive al trade</h2>
                        <p class="b-card--link">
                            Viaggi incentive 4.0
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                            </svg>                                                        
                        </p>
                    </div>
                </div>

                <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('loyalty',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-3.png')"></div>
                    <div class="b-card--text">
                        <h2 class="b-card--title">Piani loyalty</h2>
                        <p class="b-card--link">
                            Travel a punti
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                            </svg>                                                        
                        </p>
                    </div>
                </div>

                <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('regali',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-4.png')"></div>
                    <div class="b-card--text">
                        <h2 class="b-card--title">Regali aziendali</h2>
                        <p class="b-card--link">
                            Personalizzati in scala
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                            </svg>                                                        
                        </p>
                    </div>
                </div>

                <div class="b-card" fluid data-aos="fade-up" @click="mixinGoTo('welfare',{})">
                    <div class="b-card--thumb" style="background-image:url('../../../../img/home/card-5.png')"></div>
                    <div class="b-card--text">
                        <h2 class="b-card--title">Welfare aziendale</h2>
                        <p class="b-card--link">
                            Semplice, integrato, desiderato
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                            </svg>                                                        
                        </p>
                    </div>
                </div>

            </section>
        </b-container>

        <b-container fluid class="valore" data-aos="fade-up">

            <svg class="top" width="957" height="316" viewBox="0 0 957 316" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M868.302 119.6C857.802 127.7 850.502 139.3 846.002 151.8C843.702 158.4 842.002 165.3 838.502 171.3C832.002 182.3 819.802 188.8 807.702 192.7C795.502 196.6 782.702 198.6 770.902 203.4C759.002 208.2 747.802 216.7 743.802 228.8C740.602 238.7 742.702 249.6 747.102 259C751.502 268.3 758.202 276.8 767.102 281.9C777.802 288.1 790.702 289.2 803.102 290C814.602 290.7 826.102 291.2 837.602 290.3C873.502 287.6 908.202 270.9 932.602 244.4C940.902 235.4 948.202 225.1 952.402 213.6C956.602 202.1 957.702 189.1 953.902 177.5C948.902 162.3 938.002 150.3 933.502 134.8C929.702 121.9 919.002 112.4 905.602 109.8C903.102 109.3 900.502 109.1 897.902 109.1C887.302 109.1 876.702 113.1 868.302 119.6Z" fill="url(#paint0_linear_top)"/>
                <path d="M87.2025 173.1C80.5025 175.7 76.2025 182.3 73.5025 188.9C70.7025 195.5 69.1025 202.7 65.4025 208.8C60.5025 217 52.0025 222.9 42.8025 225C32.1025 227.5 21.5025 224.4 11.5025 230.5C5.80249 234 1.60252 239.9 0.402517 246.5C-2.79748 264 13.7025 270.8 27.9025 275.1C33.3025 276.7 39.0025 277.2 44.7025 277.4C50.9025 277.6 57.0025 277.5 63.2025 277.3C73.6025 277.1 84.2025 276.8 94.1025 273.3C99.3025 271.4 104.103 268.7 109.203 266.5C116.203 263.4 124.402 262.4 131.202 259.2C130.402 256.9 126.203 255.3 124.303 253.5C121.603 250.9 119.503 247.7 118.203 244.2C112.603 229.5 118.203 216.1 117.703 201.2C117.403 193.1 115.002 184.8 109.502 178.8C105.402 174.5 99.5025 171.7 93.7025 171.7C91.4025 171.9 89.3025 172.3 87.2025 173.1Z" fill="url(#paint1_linear_top)"/>
                <path d="M473.803 258.2C470.503 260.9 467.802 264.3 464.102 266.4C458.802 269.4 452.402 269.2 446.602 270C439.902 270.9 433.302 272.4 427.202 275.4C420.002 278.9 413.802 285.1 410.602 292.5C408.702 297.1 408.402 302.8 411.202 307C413.702 310.8 418.202 312.9 422.702 314C433.702 316.9 444.803 314.8 453.303 307.6C454.303 306.7 455.303 305.8 456.303 304.8C462.103 298.5 466.102 290.7 472.902 285.4C479.802 280 488.302 276.3 497.102 276.2C498.202 276.2 499.203 276.2 500.303 276.2C502.203 276.3 504.102 276.3 506.002 276.1C508.902 275.7 511.903 274.6 513.703 272.2C515.603 269.6 515.503 265.9 514.203 263C512.903 260.1 510.402 257.8 507.702 256.1C503.202 253.2 497.802 251.8 492.402 251.8C485.602 251.9 478.903 254 473.803 258.2Z" fill="url(#paint2_linear_top)"/>
                <path d="M683.802 0C674.202 0.2 665.202 4.70001 656.602 9.20001C641.502 17 626.402 24.9 611.202 32.7C580.802 48.4 546.402 64.6 513.802 54.5C495.902 48.9 481.202 36.1 464.002 28.6C446.802 21.1 423.402 20.9 412.702 36.3C407.202 44.2 406.402 54.5 401.202 62.6C394.602 73 382.102 78.1 370.002 79.6C362.802 80.5 355.502 80.4 348.202 80.3C343.202 80.2 338.302 80.2 333.302 80.4C329.702 80.6 325.802 81 322.902 83.2C319.002 86.1 317.702 91.4 317.402 96.3C316.502 114.7 327.102 132.2 341.602 143.5C356.102 154.8 374.102 160.6 392.002 164.7C457.202 179.5 525.202 172.8 589.102 155.1C621.102 146.2 652.302 134.5 682.702 121.2C699.902 113.6 721.602 106.9 730.102 88.5C743.002 60.6 736.702 26.7 710.902 9.59998C702.902 4.29998 693.802 0 684.302 0C684.202 0 684.002 0 683.802 0Z" fill="url(#paint3_linear_top)"/>
                <defs>
                <linearGradient id="paint0_linear_top" x1="849.019" y1="304.101" x2="849.019" y2="132.915" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint1_linear_top" x1="65.4635" y1="285.264" x2="65.4635" y2="185.57" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint2_linear_top" x1="462.036" y1="319.91" x2="462.036" y2="260.118" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint3_linear_top" x1="526.53" y1="185.501" x2="526.53" y2="22.6552" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg> 

            <svg class="down" width="1464" height="144" viewBox="0 0 1464 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M66.1225 2.35313C53.2225 4.95313 40.9225 10.6531 30.5225 18.6531C18.1225 28.1531 8.42247 40.8531 3.42247 55.6531C-7.57753 88.3531 8.52246 131.253 43.3225 141.353C75.9225 150.753 113.222 130.853 119.122 96.5531C122.322 77.7531 124.822 59.6531 144.122 50.8531C148.022 49.0531 152.222 47.8531 156.122 45.7531C177.022 34.4531 144.822 18.1531 135.522 13.2531C120.022 5.15312 102.522 0.453125 85.0225 0.453125C78.7225 0.453125 72.3224 1.05313 66.1225 2.35313Z" fill="url(#paint0_linear_down)"/>
                <path d="M1366.57 27.5531C1363.37 28.0531 1360.88 30.6531 1359.78 33.6531C1358.68 36.6531 1358.87 40.0531 1359.57 43.1531C1362.17 54.8531 1372.87 64.3531 1384.87 65.4531C1389.07 65.8531 1393.47 65.3531 1397.47 66.4531C1403.37 68.0531 1407.67 72.7531 1412.37 76.3531C1417.77 80.4531 1423.57 84.0531 1429.97 86.2531C1437.57 88.8531 1446.28 88.9531 1453.78 85.8531C1458.38 83.9531 1462.57 80.1531 1463.57 75.2531C1464.47 70.7531 1462.77 66.1531 1460.47 62.1531C1454.77 52.3531 1445.37 45.9531 1434.37 45.0531C1433.07 44.9531 1431.68 44.9531 1430.28 44.9531C1421.78 45.2531 1413.38 47.9531 1404.78 46.9531C1396.08 45.9531 1387.47 42.5531 1381.07 36.3531C1378.97 34.2531 1377.08 31.9531 1374.78 30.1531C1372.78 28.5531 1370.28 27.4531 1367.78 27.4531C1367.48 27.4531 1367.07 27.4531 1366.57 27.5531Z" fill="url(#paint1_linear_down)"/>
                <defs>
                <linearGradient id="paint0_linear_down" x1="81.352" y1="154.178" x2="81.3519" y2="19.2274" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint1_linear_down" x1="1411.3" y1="92.6437" x2="1411.3" y2="35.4148" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="left" width="228" height="479" viewBox="0 0 228 479" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M74.7999 451C55.6999 474.6 29 484.2 0 475V44.6104C7.33642 40.4863 14.7283 36.4635 22.2 32.6002C41 22.9002 60.5 14.0002 81.2 9.4002C135.1 -2.6998 201.5 -11.0999 223.1 52.0001C231.2 75.8 228.7 102.9 216.3 124.7C194.6 162.8 154.5 172.3 124.3 200C98.0999 224.1 81.0999 258.6 80.2999 294.4C79.6999 321.2 87.2999 347.5 90.4999 374.2C93.6999 400.9 91.6999 430.1 74.7999 451Z" fill="url(#paint0_linear_left)"/>
                <defs>
                <linearGradient id="paint0_linear_left" x1="113.652" y1="513.449" x2="113.651" y2="63.5174" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="right" width="151" height="761" viewBox="0 0 151 761" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M63.9866 26.9161C29.4133 54.5284 10.1543 98.6152 8.06603 142.934C5.9777 187.021 19.6678 231.108 41.7112 269.393C53.313 289.581 67.4671 308.84 75.1243 330.883C89.0465 371.257 79.301 416.272 62.8264 455.718C46.3519 495.164 23.6124 532.058 10.3864 572.664C-3.07169 613.27 -5.85612 660.374 16.6513 696.803C34.7501 726.272 67.2351 744.602 100.88 753.884C117.123 758.293 134.061 760.845 151 760.845V0.464071C147.287 0.232035 143.807 0 140.094 0C112.946 0 86.03 9.28143 63.9866 26.9161Z" fill="url(#paint0_linear_right)"/>
                <defs>
                <linearGradient id="paint0_linear_right" x1="75.3414" y1="816.608" x2="75.34" y2="99.732" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>            

            <section>
                <h2 class="section--title white">Il valore del nostro travel per la tua azienda</h2>
                <p class="paragraph">
                    Da sempre i viaggi sono elementi chiave dei sistemi di <b>rewarding</b> aziendale. 
                    <br><br>
                    Mai, prima di Vivamod, i viaggi erano stati <b>integrati in modo così semplice</b> ed entusiasmante dentro al tuo business.
                </p>

                <p class="paragraph text-center">
                    <br><br>
                    <b>Vivamod è:</b>
                </p>

                <div class="boxes">
                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">Travel tech flessibile e robusta al tuo servizio</span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>                        
                    </div>
                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">User Experience all’altezza delle attese dell’utente contemporaneo</span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>                        
                    </div>
                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">Un’assistenza al viaggiatore attenta, disponibile e multicanale</span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>                        
                    </div>
                </div>

                <br><br>

                <a class="btn btn-lg">
                    <span>scopri di più</span>
                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                        <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                        <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                    </svg>                            
                </a>
            </section>

        </b-container>

        <b-container class="prods" data-aos="fade-up">
            <section>
                <b-row class="align-items-center">
                    <b-col sm="12" lg="5" offset-lg="1">
                        <h3 class="section--title text-left">Prodotti</h3>
                        <p>
                            Scopri le nostre soluzioni di online <b>travel booking integrate</b> con le tue piattaforme IT.
                        </p>
                        <p>
                            <b>Credito travel digitale</b>, gift card digitali, cofanetti regalo digitali. 
                        </p>
                        <p>
                            Gift card e <b>cofanetti regalo tradizionali</b> brandizzabili.
                        </p>
                        <p>
                            Ogni prodotto contiene la nostra tecnologia di travel booking flessibile e sicura. 
                            Ogni nostro prodotto si avvale di un solido <b>sistema di customer care al servizio dei tuoi clienti</b> e dei tuoi collaboratori.
                        </p>
                    </b-col>
                    <b-col sm="12" lg="5">
                        <div class="image">
                            <img src="img/home/phona-prod.png" />
                            <div class="btn btn-lg">
                                <span>scopri di più</span>
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" offset-lg="1">
                        <svg class="dot" width="142" height="142" viewBox="0 0 142 142" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="71" cy="71" r="71" fill="url(#paint0_linear)"/>
                        <defs>
                        <linearGradient id="paint0_linear" x1="70.8509" y1="152.407" x2="70.8508" y2="18.6134" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF974F"/>
                        <stop offset="0.00128142" stop-color="#FF974F"/>
                        <stop offset="1" stop-color="#FF5652"/>
                        </linearGradient>
                        </defs>
                        </svg>
                    </b-col>
                </b-row>
            </section>
        </b-container>

        <b-container data-aos="fade-up">
            <section class="text-left">
                <b-row>
                    <b-col sm="12" lg="8" offset-lg="2">
                        <h3 class="section--title">Ci sintonizziamo con i tuoi valori</h3>
                        <div class="intro">
                            <p class="section--subtitle">
                                Vivamod permette di creare canali di viaggio tematici disegnati su misura per potenziare i messaggi delle tue campagne ed esprimere i tuoi valori aziendali.
                            </p>
                            <p>
                                Un universo di viaggi, oltre <strong>500.000 hotel, B&B, appartamenti</strong> in Italia e nel mondo disponibili in tempo reale.
                            </p>
                        </div>
                    </b-col>
                </b-row>

                <br><br><br>

                <b-row>
                    <b-col sm="12">
                        <div class="text-center h4">Ecco solo alcuni esempi</div>
                    </b-col>
                </b-row>

                <br><br>

                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="bSlickOptions">
                                    <div v-for="(i,index) in [1,2,3,4,5,6,7,8,9,10,11,12,13]" v-bind:key="index">
                                    <div class="b-slide">
                                        <div class="content">
                                            <img class="phone" src="img/home/slider-sintonizzati/phone.png" />
                                            <img class="screen" :src="'img/home/slider-sintonizzati/Vivamod_IN_VadoBay_'+i+'.jpg'" />
                                        </div>
                                    </div>
                                    </div>
                                </Slick>
                            </div>

                            <div class="b-left" id="b-left">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>   

        <b-container class="branding" data-aos="fade-up">
            <div class="background" style="background-image:url('../../../../img/home/bg.jpg')"></div>
            <b-row>
                <b-col sm="12" lg="6" offset-lg="6">
                    <div class="content">
                        <h3 class="section--title">Il tuo branding, la tua identità</h3>
                        <p class="section--subtitle">Le nostre soluzioni sono pensate per potersi allineare perfettamente con la tua brand identity.</p>
                        <hr />
                        <p>
                            I tuoi clienti e i tuoi collaboratori potranno vivere un’esperienza di travel booking straordinaria all’interno di un eco-sistema che rispetta la tua brand identity e i tuoi valori di marca.
                        </p>

                        <br>
                    
                        <div>
                            <div class="btn btn-lg">
                                <span>scopri di più</span>
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <b-container fluid v-if="postsCategory != 0">
            <section class="mt-0 pt-0">
                <PostSlider :category="postsCategory" />
            </section>
        </b-container>

        <b-container data-aos="fade-up">
            <section>
                <FormContatti
                    formTitle="Contattaci"
                    formSubtitle="Per approfondire meglio le nostre soluzioni e quello che possiamo fare per il tuo marketing"
                />
            </section>
        </b-container>

    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import SvgChevronLeft from '@/components/svg/chevron-left'
    import SvgChevronRight from '@/components/svg/chevron-right'
    import FormContatti from '@/components/blocks/form-contatti'
    import PostSlider from '@/components/blocks/post-slider'

    export default {
        name: 'homepage',
        metaInfo: {
          title: 'Travel booking - Soluzioni online per il marketing',
          meta: [
            { vmid: 'metaDescription', name: 'Description', content: 'Soluzioni online integrate, brandizzate, capaci di comunicare i valori e i messaggi della tua azienda. Disponibilità di viaggio in tempo reale.' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Soluzioni online integrate, brandizzate, capaci di comunicare i valori e i messaggi della tua azienda. Disponibilità di viaggio in tempo reale.' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Travel booking - Soluzioni online per il marketing | Vivamod' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Soluzioni online integrate, brandizzate, capaci di comunicare i valori e i messaggi della tua azienda. Disponibilità di viaggio in tempo reale.' },
          ],
        },
        components: {
            Slick,
            SvgChevronLeft,
            SvgChevronRight,
            FormContatti,
            PostSlider,
        },
        data()
        {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots:false,
                    fade:true,
                    arrows:true,
                    autoplay:true,
                    speed: 1500,
                    autoplaySpeed: 5500,
                    prevArrow: '#hero-slider-prev',
                    nextArrow: '#hero-slider-next',
                    responsive: [{
                        /*
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                        */
                    }]
                },
                bSlickOptions: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left',
                        nextArrow: '#b-right',
                        responsive: [{
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }]
                },
                postsCategory: parseInt(process.env.VUE_APP_BLOG_BUSINESS_CATEGORY_ID)
            }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';
    #homepage
    {
        .hero-drops
        {
            width:100%;
            overflow:hidden;
            max-width:1920px;
            position:relative;

            .drop-gray-1
            {
                position:absolute;
                top:46px;
                left:25%;
                width:46px;
                height:auto;
            }

            .drop-gray-2
            {
                position: absolute;
                top: 75%;
                left: 40%;
                width: 40px;
                height: auto;
            }

            .drop-red-1
            {
                position:absolute;
                top:-8px;
                left:51%;
                width:100px;
                height:auto;
                z-index:1;
            }

            .drop-red-2
            {
                position:absolute;
                top:32.5%;
                right:1%;
                width:20px;
                height:auto;
                z-index:1;
            }

            .drop-red-3
            {
                position:absolute;
                bottom:15%;
                right:-10px;
                width:30px;
                height:auto;
                z-index:1;
            }

            .drop-red-4
            {
                position:absolute;
                bottom:-10%;
                left:60%;
                width:60px;
                height:auto;
                z-index:1;
                @include media-breakpoint-down(xl)
                {
                    bottom:0 !important;
                }
            }

            .slider
            {
                position:relative;
                &--nav
                {
                    position:absolute;
                    padding:5px;
                    bottom:0;
                    display:flex;
                    .arrow
                    {
                        cursor:pointer;
                        transition:$transition-base;
                        &:hover
                        {
                            opacity:0.7;
                        }
                        path
                        {
                            stroke:$secondary;
                        }
                    }
                    @include media-breakpoint-up(lg)
                    {
                        right:0;
                        bottom:60px;
                        left:auto;
                        .arrow
                        {
                            padding:10px 20px;
                            svg
                            {
                                height:auto;
                                width:40px;
                            }
                        }
                    }
                }
            }
            .slide
            {
                //background-size: contain;
                //background-position: center center;
                //min-height: 200px;
                width:100%;
                //border:1px solid red;
                display:flex !important; //altrimenti slick, as usual, la sovrascrive con inline-block
                justify-content: flex-end;
            }
            .image
            {
                width:72.5vw;
                position:relative;
                transform:translateX(25%);
            }
            .thumb
            {
                position:absolute;
                height: auto;
                width:100%;
                top:-3px;
                right:0px;
            }
            .holder
            {
                width:100%;
                height: auto;
            }
            .caption
            {
                position:absolute;
                top:50%;
                left:0;
                width:45%;
                //transform:translateY(-50%);
                padding:$grid-gutter-width/6;
                //border:1px solid green;
            }
            .small
            {
                display:none;
                margin:0;
                color:$dark-blue;
                //font-weight:700;
                //&.not-first
                //{
                //    color:$light-gray;
                //    font-weight: 400;
                //}
            }
            .text
            {
                //color:$tertiary;
            }

            @include media-breakpoint-up(sm)
            {
                .drop-gray-1
                {
                    width:65px;
                    left:18.5%;
                    top:26.5%;
                }
                .drop-gray-2
                {
                    top: 82%;
                    left: 40%;
                    width: 60px;
                }
                .drop-red-1
                {
                    width:36%;
                    left:45%;
                }
                .drop-red-2
                {
                    width:50px;
                    top:25%;
                    right:5%;
                }
                .drop-red-3
                {
                    width:100px;
                    transform:none;
                    right:0;
                    top:50%;
                }
                .drop-red-4
                {
                    width:100px;
                    left:55%;
                    bottom:-13%;
                }
                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    width:60vw;
                    transform:none;
                }
                .thumb
                {
                }
                .holder
                {
                }
                .caption
                {
                    padding:$grid-gutter-width/2;
                    font-size:16px;
                }
                .small
                {
                    display:block;
                    max-width:75%;//220px;
                }
                .text
                {
                    margin:0.5rem 0;
                }
            }

            @include media-breakpoint-up(xxl)
            {
                .drop-gray-1
                {
                    width: 120px;
                    left: 11.5%;
                    top: 12.5%;
                }
                .drop-gray-2
                {
                    top: 62%;
                    left: 37%;
                    width: 180px;
                }
                .drop-red-1
                {
                    width:30%;
                    left:42%;
                }
                .drop-red-2
                {
                    width:80px;
                    top:22%;
                    right:6%;
                }
                .drop-red-3
                {
                    width:240px;
                    //transform:none;
                    right:0;
                    top:35%;
                }
                .drop-red-4
                {
                    width:220px;
                    left:57.5%;
                    bottom:3%;
                }
                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    //width:60vw;
                    //transform:none;
                    max-width:1200px;
                    top:-100px;
                }
                .thumb
                {
                    top:4px;
                }
                .holder
                {
                }
                .caption
                {
                    padding:0;
                    margin:0 $grid-gutter-width*2;
                    //font-size:16px;
                    transform:translateY(-50%);
                }
                .small
                {
                    //max-width:360px;
                    position:absolute;
                    left:0;
                    margin:0;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    max-width:680px;
                }
            }            
        }

        .b-icons
        {
            text-align: center;
            .b-icon
            {
                svg
                {
                    width:auto;
                    height:80px;
                }
            }
            .text
            {
                font-size: 18px;
                font-weight: 400;
                margin-top:20px;
            }
        }
        
        .prods
        {
            //color:#9D9D9C;
            .dot
            {
                max-width: 80px;
                @include media-breakpoint-up(lg)
                {
                    max-width: 120px;
                    transform:translateY(-70%);
                }
            }
            .image
            {
                //position:absolute;
                //left:50%;
                //top:75%;
                margin-top:40px;
            }
            .btn
            {
                position:absolute;
                bottom:10%;
                right:10%;
            }
        }

        .branding
        {
            position:relative;
            margin-bottom:40px;
            @include media-breakpoint-up(lg)
            {
                min-height:800px;
                margin-bottom:140px;
                .content
                {
                    position:relative;
                    max-width: 500px;
                    top:50%;
                }
            }
            .background
            {
                display:none;
                @include media-breakpoint-up(lg)
                {
                    display:block;
                    position:absolute;
                    width:100%;
                    height:100%;
                    //background-size: contain;
                    background-repeat: no-repeat;
                    background-position: left center;
                    border-radius:15px;
                }
            }
        }
        
    }
</style>